export default __webpack_public_path__ + "static/media/Lightning.7e2e9c7f.png";